import { ApplicationTarget } from './interfaces';

export const jobDetailsGetExternalLink = (
  target: ApplicationTarget,
  externalTarget?: string,
  path?: string
) => {
  if (
    externalTarget &&
    (target === 'externalTarget' || target === 'hybridExternalTarget')
  ) {
    return externalTarget;
  }
  return path + '/apply';
};
